import React, { useEffect, useState } from 'react';
import emailService, { EmailMailbox } from '../../../services/emailService';
import EmailDeliverabilityPanel from './EmailDeliverabilityPanel';
import WarmupHealthPanel from './WarmupHealthPanel';
import TrackingDomainsPanel from './TrackingDomainsPanel';
import DomainHealthPanel from './DomainHealthPanel';

const EmailDeliverabilityHub: React.FC = () => {
  const [mailboxes, setMailboxes] = useState<EmailMailbox[]>([]);
  const [selectedMailboxId, setSelectedMailboxId] = useState<string>('');

  useEffect(() => {
    const load = async () => {
      try {
        const m = await emailService.getMailboxes();
        setMailboxes(m);
        if (m.length > 0 && !selectedMailboxId) {
          setSelectedMailboxId(m[0].id as string);
        }
      } catch (e) {
        console.error('Failed to load mailboxes for Deliverability Hub', e);
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-4">
      <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
        <h2 className="text-2xl font-bold text-gray-800 mb-1">Deliverability Hub</h2>
        <p className="text-sm text-gray-600 max-w-3xl">
          Keep your emails landing in the inbox. Explanatum automatically warms each connected mailbox (up to 20 warmup emails per
          day) and caps campaign sending at 30 emails per mailbox per day to protect your domain reputation. Warmup messages are
          tagged and kept out of your main inbox, while you monitor mailbox health, domain reputation, warmup progress, and
          tracking domains in one place.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <EmailDeliverabilityPanel />
        <DomainHealthPanel />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {selectedMailboxId ? (
          <WarmupHealthPanel mailboxId={selectedMailboxId} />
        ) : (
          <div className="bg-white p-4 rounded-lg shadow border border-gray-200 flex items-center justify-center text-sm text-gray-600">
            Connect a sending mailbox to see warmup health recommendations.
          </div>
        )}
        <TrackingDomainsPanel />
      </div>
    </div>
  );
};

export default EmailDeliverabilityHub;
